<template>
<v-container
  fluid
  class="grey lighten-5"
>

  <v-tabs
    v-model="tab"
    class="mt-0 pt-0"
  >
    <v-tab
      v-for="item in items"
      :key="item.tab"
    >
      {{ item.tab }}
    </v-tab>

    <!-- <v-select
      label="[select notebook]"
      :items="labels"
      item-text="name"
      dense
      solo
      class="mt-1"
      outlined
      filled
      single-line
      >
    </v-select> -->

  </v-tabs>

  <v-spacer></v-spacer>


      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in items"
          :key="item.tab"
        >


<v-layout row>


      <!-- [0]['attributes']['hostname'].replace(/^www\./, '').replace(/\.com$/, '') -->

<!--   <v-list
  align-top
  
   >
    <v-list-item
      v-for="(l, dayS) in labels"
      :key="dayS"
      icon="mdi-event"
      small
      color="orange"
    >
    <v-btn>
    {{ l.name }}
    </v-btn>

</v-list-item>
 </v-list> -->



  <v-list
  align-top
  
   >

    <v-list-item
      v-for="(l, dayS) in byDay"
      :key="dayS"
      icon="mdi-event"
      small
      color="orange"
    >
<!--     <template v-slot:icon>
      <v-avatar v-if="avatar" small>
      </v-avatar>
    </template>
 -->
        <!-- <v-img :src="require('../assets/telegram.png')"/> -->
        <!-- <img src="<%= BASE_URL %>favicon.ico"> -->
        <!-- <img src="http://i.pravatar.cc/64"> -->
    <!-- <span slot="opposite">perfecto</span> -->
    <!-- <span>{{ dayS }}</span> -->



  <v-layout row wrap justify-center>

    <v-flex xs12 sm11 md10 lg10 xl5
              
          >

            <v-card
              outlined
              elevation=3
              class="mt-2"
            >
              <!-- <h3 class="pa-8">{{ dayS }}</h3> -->
     <!-- <v-divider class="mt-12"></v-divider> -->
              <v-subheader class="title">{{ dayS }}</v-subheader>

              <v-list two-line>
                <!-- <template > -->
                  <v-list-item
                    v-for="doc in l"
                    :key="doc.id"
                    @click="showPreview(doc.id)"
                    class="tline-item"
                    
                  >
<!--                     <v-list-item-avatar color="grey darken-1">
                    <img src="https://randomuser.me/api/portraits/men/88.jpg">
                    </v-list-item-avatar> -->

                    <!-- <v-list-item-action>         -->
                      <v-list-item-icon class='mr-1 mt-2'>
                      <v-icon
                        @click.stop="fliploveit(doc.id)"
                        :color="loveitcolor(doc.id)"
                        class="mt-2"
                        small
                      >
                          mdi-heart
                      </v-icon>

                      <v-icon
                        @click.stop="$store.dispatch('flipSeenIt', doc.id);"
                        :color="seenitcolor(doc.id)"
                        class="mt-2"
                        small
                      >
                          mdi-check
                      </v-icon>

                      </v-list-item-icon>

                    <!-- </v-list-item-action> -->


                    <v-list-item-content>
                      <v-list-item-title>{{ doc.attributes.note }}</v-list-item-title>

                      <v-list-item-subtitle>
                      <!-- {{ doc.attributes.created_time }} -->
                      {{ doc.attributes.url.replace(/^https:\/\//, '').replace(/\/.*/, '').replace(/\.com$/, '').replace(/^www\./, '') }}

                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>        
                      <v-list-item-icon class='mx-0  pa-0 mt-0'>
                        <v-icon
                          @click.stop="showEdit(doc.id)"
                          color="grey"
                          small
                          class="mt-3"

                          
                        >mdi-dots-vertical
                        </v-icon>
                      </v-list-item-icon>
                    </v-list-item-action>

                  </v-list-item>

<!--            

mdi-wrench
       <v-divider
                    v-if="n !== 6"
                    :key="`divider-${n}`"
                    inset
                  ></v-divider>
                </template> -->

              </v-list>
            </v-card>



    </v-flex>
  </v-layout>

    </v-list-item>
  </v-list>

</v-layout>

        </v-tab-item>
      </v-tabs-items>

<!--     <v-layout column>
      <v-flex>
        <CardsLine
          header="Chatbot"
          :data="recent"
        />
        <div class="text-left">
          <v-btn @click="getMoreRecent()">
            More
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
 -->
</v-container>
</template>


<script>
// import CardsLine from '../components/CardsLine';
// import Card from '../components/Card';
// import { mapState, mapGetters } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'Recent',
  components: {
    //CardsLine,
    // Card
  },
  mounted () {
    this.$store.dispatch("sync");
  },
  methods: {
    getMoreRecent () {
      this.$store.dispatch("extendRecent");
    },
    showEdit(docID) {
      console.log('  - click showEdit [Recent]')
      console.log(`    docID: ${docID}`)
      this.$store.dispatch('ui/showEditForm', docID)
      // this.editVisible = true;
      // console.log(this.$refs.preview);
      // this.$refs.preview.focus();
    },
    showPreview(docID) {
      console.log('  - click showPreview [Recent]')
      console.log(`    docID: ${docID}`)
      this.$store.dispatch('ui/showPreviewWin', docID)      
      // this.showDialog = true;
      // console.log(this.$refs.preview);
      // this.$refs.preview.focus();
    },
    fliploveit(docID) {
      var ret = this.$store.dispatch("flipLoveIt", docID);
      return ret;
    },

    // flipseenit(docID) {
    //   var ret = this.$store.dispatch("flipSeenIt", docID);
    //   return ret;
    // },

    getContent(content) {
      // console.log(content);
      // var doc = this.$store.getters.included(docID)
      // var acc = []
      var ret = []
      if (content === 'recent') {
        ret =  this.isNotSeen;
      } else if (content === 'seen') {
        ret =  this.isSeen;
      } else if (content === 'loveit') {
        ret =  this.loveit;
      }
      // for (doc in ret) {
      //   console.log(doc)
      //   var doc = this.$store.getters.included(doc.id)
      //   acc.push(doc)
      // }

      return ret
    },

  },
  data: () => ({
    tab: 0,
    avatar: true,
    labels: [
      { name: '[NONE]' },
      { name: 'ML' },
      { name: 'Physics' },
      { name: 'Modelling' },
      { name: 'Cooking' },
    ],
    items: [
      { tab: 'Inbox', content: 'recent' },
      { tab: 'Favs', content: 'loveit' },
      { tab: 'Archive', content: 'seen' },
      { tab: 'Feeds', content: 'feed' },
      { tab: 'Tabs', content: 'feed' },
    ]
  }),
  // mounted() {
  // },  
  computed: {
    // ...mapGetters(['recent']),
    // ...mapState(['loveit', 'feed',]),
    ...mapGetters(['isSeen', 'isNotSeen', 'isLoved']),

    loveitcolor() {
      return docID => {
        var doc = this.$store.getters.included(docID)
        // console.log(doc)
        return doc.loveit ? 'red' : 'grey lighten-1';
      }
    },

    seenitcolor() {
      return docID => {
        var doc = this.$store.getters.included(docID)
        // console.log(doc)
        return doc.seenit ? 'blue lighten-1' : 'grey lighten-1';
      }
    },
    byDay () {
      var ret = {}
      var items = null

      let hmm  = this.items[this.tab]
      if (hmm) {
        console.log(hmm.content)
        items = this.getContent(hmm.content)
      } else  {
        console.log('default content')
        items = this.$store.state.included
      }
      // console.log(items)

      for (var d of items) {
        // if (!d.attributes.loveit) continue

        var ct = d.attributes.created_time
        var tstamp = ct.split('T')[0]

        // let dd = new Date(ct)
        // let ds = dd.getDate()
        // let tstamp = `${dd.getFullYear()}-${dd.getMonth()+1}-${ds}`
        // console.log(`DocID(${d.id}) ${tstamp}`)

        if (tstamp in ret) {
          // console.log('tstamp found')
          ret[tstamp].push(d)
        }
        else {
          ret[tstamp] = [d]
        }
      }
      // console.log(ret)
      return ret
    },

    recent() {
      return this.$store.getters.recent;
    },

    loveit() {
      return this.$store.getters.isLoved;
    }

  },    
};
</script>


<style scoped>
.tline-item {
  height: 20px;
}
</style>
